export default "__VITE_ASSET__ea659993__"